// extracted by mini-css-extract-plugin
module.exports = {"container":"periodTab_container__38zsL","welcomeText":"periodTab_welcomeText__3p8Tj","tabContainer":"periodTab_tabContainer__wM6b6"};